import React from 'react';
import PropTypes from 'prop-types';
import classname from 'classnames';
import { Icon } from 'lidya-common-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { useGlobalData } from '../../providers/globalDataProvider/globalDataProvider.useGlobalData';
import { ADDRESSES } from '../common/webSiteVariables';

const Telephone = function ({ className }) {
  const { country } = useGlobalData();
  const countryDetails = ADDRESSES[country][0];
  const { phone } = countryDetails;
  if (!phone) return null;

  return (
    <a
      href={`tel:${phone}`}
      className={classname(['m-navigation__contact_tip', className])}
    >
      <Icon name="telephone" className="m-navigation__contact_tip__icon" />
      <span className="m-navigation__contact_tip__text">{phone}</span>
    </a>
  );
};

Telephone.propTypes = {
  className: PropTypes.string,
};

Telephone.defaultProps = {
  className: undefined,
};

const MailTo = function ({ className }) {
  const { t } = useTranslation();
  const { country } = useGlobalData();
  const countryDetails = ADDRESSES[country][0];
  const { email } = countryDetails;
  if (!email) return null;
  return (
    <a
      href={`mailto:${email.to}${
        email.subject ? `?subject=${t(email.subject)}` : ''
      }`}
      className={classname(['m-navigation__contact_tip', className])}
    >
      <Icon name="email" className="m-navigation__contact_tip__icon" />
      <span className="m-navigation__contact_tip__text">{email.to}</span>
    </a>
  );
};

MailTo.propTypes = {
  className: PropTypes.string,
};

MailTo.defaultProps = {
  className: undefined,
};

export const NavContactElement = function ({ className }) {
  return (
    <>
      <MailTo
        className={className}
      />
      <Telephone
        className={className}
      />
    </>
  );
};

NavContactElement.propTypes = {
  className: PropTypes.string,
};

NavContactElement.defaultProps = {
  className: undefined,
};

export default NavContactElement;
